export const SearchStatusMessages = {
  OUT_OF_SCOPE: "Out of application scope",
};
